import { Routes } from '@angular/router';

export const routes: Routes = [
    {
        path: '',
        pathMatch: 'full',
        loadComponent: () => import('./home/home.component').then(m => m.HomeComponent)
    },
    {
        path: 'd/:id',
        loadComponent: () => import('./home/doctor-profile/doctor-profile.component').then(m => m.DoctorProfileComponent)
    },
    {
        path: 'f/:id',
        loadComponent: () => import('./home/clinic-profile/clinic-profile.component').then(m => m.ClinicProfileComponent)
    },
    {
        path: '**',
        redirectTo: ''
    }
];
